import { Stack, StackProps, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";

export interface DashboardButtonType extends StackProps {
    to: string;
    text: string;
    Icon: IconType;
}
export default function DashboardButtons(props: DashboardButtonType) {
    return (
        <Stack
            p={8}
            as={Link}
            w={'full'}
            spacing={2}
            rounded={'2xl'}
            color={'white'}
            align={'center'}
            justify={'center'}
            bg={'primary.500'}
            _hover={{ bg: 'primary.600' }}
            _active={{ bg: 'primary.700' }}
            {...props}
        >
            <props.Icon fontSize={'24px'} />
            <Text>{props.text}</Text>
        </Stack>
    )
}